import { useCallback, useRef } from "react";
import { useDebouncedCallback } from "use-debounce";

type Callback<A> = (a: A) => void;

export default function useDebouncedQueue<A, B>(
  enqueue: (a: A) => B,
  handler: Callback<B[]>,
  delay: number = 500
): Callback<A> {
  const queue = useRef<B[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [handleQueue, _cancelQueue, _flushQueue] = useDebouncedCallback(() => {
    try {
      handler(queue.current);
    } finally {
      queue.current = [];
    }
  }, delay);

  const wrapped = useCallback(
    (a: A) => {
      const b = enqueue(a);
      handleQueue();
      queue.current = [...queue.current.filter(x => x !== b), b];
    },
    [enqueue, handleQueue]
  );

  return wrapped;
}
